import { default as Vuex, Module } from "vuex";

import AppSettings from "@/app-settings";

class AppSettingsModuleState {
	appSettings: AppSettings = new AppSettings();
}

class AppSettingsModule implements Module<AppSettingsModuleState, any> {
	namespaced = true;
	state: AppSettingsModuleState = new AppSettingsModuleState();
	mutations = {
		SET_APP_SETTINGS(state: AppSettingsModuleState, payload: AppSettings)  {
			state.appSettings = payload;
		}
	};
	actions = {
		// setDarkMode({ state, commit, rootState }: { state: AppSettingsModuleState, commit: any, rootState: any}, isDarkMode: boolean) {
		// 	state.appSettings.isDarkMode = isDarkMode;
    // }
	}
}

const appSettingsModule: AppSettingsModule = new AppSettingsModule();

export default appSettingsModule;
